import { useClientQueryWithErrorHandling } from '@ts-private/apollo-tools';
import { emptyFunction } from 'utils/constants';
import { ServiceContext } from 'providers/ServiceProvider';
import { useCallback, useContext } from 'react';
import { useSimpleError } from 'hooks/apolloWrappers';

const useClientQuery = () => {
  const [activeService] = useContext(ServiceContext);
  const showError = useSimpleError();
  const clientQuery = useClientQueryWithErrorHandling();

  const clientQueryInternal = useCallback(
    async (query, options) => {
      const { onError = emptyFunction, ...restOptions } = options || {};

      return await clientQuery(query, {
        ...restOptions,
        context: { serviceName: activeService?.name },
        onError: error => {
          onError(error);
          showError(error);
        },
        skip: restOptions?.skip || !activeService?.name
      });
    },
    [activeService?.name, clientQuery, showError]
  );

  return clientQueryInternal;
};

export default useClientQuery;
